<template>
  <div class="grid-container text-base">
    <section-header size="xl" variants="dividing">
      <heading qaid="ps-order-form-order-form-heading" level="1" size="xl" v-html="bp('virtualPackingSlip')" />
      <div v-if="isVisibleDownloadButton" class="buttons buttons--right-for-md">
        <trek-button primary small qaid="packing-slip-download" @click="downloadPackingSlip">
          <span v-html="bp('download')" />
        </trek-button>
      </div>
    </section-header>
    <virtual-packing-slip-shipment-details :shipment-details="packingSlipData" :base-properties="baseProperties" />
    <virtual-packing-slip-order-details
      :packing-orders="packingSlipData.orderLines"
      :bill-to-number="packingSlipData.billToNumber"
      :base-properties="baseProperties"
    />
  </div>
</template>

<script>
import {mapState} from 'vuex';
import SectionHeader from '@/components/SectionHeader';
import VirtualPackingSlipShipmentDetails from '@/components/containers/my-account/VirtualPackingSlipShipmentDetails';
import VirtualPackingSlipOrderDetails from '@/components/containers/my-account/VirtualPackingSlipOrderDetails';
export default {
  props: {
    packingSlipData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState('backend', ['encodedContextPath']),

    isVisibleDownloadButton() {
      const shipmentDate = new Date(this.packingSlipData.actualShipDate);
      const currentDate = new Date();
      const differenceInTime = currentDate.getTime() - shipmentDate.getTime();
      const differenceInDays = differenceInTime / (1000 * 3600 * 24);
      return differenceInDays < 90;
    },
  },
  methods: {
    downloadPackingSlip() {
      window.location.href = `${this.encodedContextPath}/my-account/packingslip-data/${this.packingSlipData.packingSlipNumber}/${this.packingSlipData.shipToNumber}`;
    },
  },
  component: {SectionHeader, VirtualPackingSlipShipmentDetails, VirtualPackingSlipOrderDetails},
};
</script>
